<ion-app [class]="getCurrentTheme()">
  <ion-router-outlet
    [animated]="false"
    class="main-router-outlet"
  ></ion-router-outlet>

  @if (appMode === 'development') {
    <div class="devmode showOnHover">
      <div class="row justify-content-center align-items-center">
        <div class="col text-left">Mode développement</div>
        <div class="col-auto">
          <ion-button fill="solid" (click)="redirectToStoryBook()">
            Storybook
          </ion-button>
        </div>
      </div>
    </div>
  }

  @if (appMode === 'staging') {
    <div class="stagingmode showOnHover">
      <div class="row justify-content-center align-items-center">
        <div class="col text-left">Mode staging</div>
        <div class="col-auto">
          <ion-button fill="solid" (click)="redirectToStoryBook()">
            Storybook
          </ion-button>
        </div>
      </div>
    </div>
  }

  @if (appMode === 'release') {
    <div class="productionmode showOnHover">
      <div class="row justify-content-center align-items-center">
        <div class="col text-left">Mode release</div>
      </div>
    </div>
  }
</ion-app>
